var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-link',_vm._b({on:{"click":_vm.confirmDelete}},'vl-link',_vm.$_attributes,false),[(!_vm.$_label)?_c('i',{staticClass:"icon-trash",attrs:{"title":_vm.deleteTitle}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }